// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import { withRouter } from 'react-router-dom'
import { pick } from 'lodash'

import {
  WhatsAppRelatedMessagesList as RelatedMessagesList,
  WhatsAppMessageEventsList as MessageEventsList,
  WhatsAppMessageEventDetails as EventDetails
} from '../components'

import {
  hasResponsibility
} from '../utils'

import {
  EventContext
} from '../context'


class WhatsAppMessage extends React.PureComponent {
  state = {
    messageId: this.props.messageId || this.props.match.params.messageId,
    eventId: null,
    changeEventId: (eventId) => this.setState({ eventId })
  }

  goToMessageListingPage = () => (
    this.props.history.goBack()
  )

  changeMessageId = messageId => this.setState({ messageId })

  render() {
    const messageId = this.state.messageId
    const hasEventsViewingPermission = hasResponsibility("self", 'view_whatsappmessages_events', 'whatsappmessage', null)

    return (
      <div className='slds-size_1-of-1 slds-grid slds-wrap'>
        <EventContext.Provider value={pick(this.state, ['eventId', 'changeEventId'])}>
          <section className='slds-col slds-small-size_1-of-1 slds-medium-size_1-of-3 slds-align_absolute-center message-detail-container slds-scrollable_y'>
            <RelatedMessagesList
              initialMessageId={this.props.messageId || this.props.match.params.messageId}
              currentMessageId={this.state.messageId}
              changeMessageId={this.changeMessageId}
              className='rounded-container slds-size_1-of-1 slds-m-around_small'
            />
          </section>
          {hasEventsViewingPermission &&
            <React.Fragment>
              <section className='slds-col slds-small-size_1-of-1 slds-medium-size_1-of-3 slds-align_absolute-center message-detail-container slds-p-left_small slds-p-right_small slds-scrollable_y'>
                <MessageEventsList messageId={messageId} />
              </section>
              <section className='slds-col slds-grid_vertical slds-small-size_1-of-1 slds-medium-size_1-of-3 slds-align_absolute-center message-detail-container slds-p-left_small slds-p-right_small slds-scrollable_y'>
                <EventDetails eventId={this.state.eventId} />
              </section>
            </React.Fragment>
          }
        </EventContext.Provider>
      </div>
    )
  }
}

export default withRouter(WhatsAppMessage)



// WEBPACK FOOTER //
// ./src/containers/WhatsAppMessage.js